import * as ACTION from './constants';
import * as apiService from '../../services/apiServices';
import { Dashboard, DashboardForm } from '../../core/model';
import {formatDataToModel } from '../../utils';

// ACTION CREATORS
export const dashboardBase = () => ({ type: ACTION.DASHBOARD_BASE });
export const isDashboardLoading = () => ({ type: ACTION.DASHBOARD_LOADING });
export const dashboardLoaded = (data = null) => ({ type: ACTION.DASHBOARD_LOADED, data });

export const getDashboard = (params) => (dispatch, getState) => {
  return new Promise((resolve, reject) => {
    dispatch(isDashboardLoading());
    apiService.getDashboard(params)
    .then(response => {
      const authState = getState().authState;
      const dashboardObj = formatDataToModel(response, Dashboard);
      const dashboardForm = new DashboardForm()
      dashboardForm.formatForForm({ ...dashboardObj, trainer_relationship: authState.userData.trainer_relationship });
      dispatch(dashboardLoaded(dashboardForm));
      resolve(response);
    })
    .catch(error => {
      dispatch(dashboardBase());
      reject(error);
    });
  });
}
